const state = {
    catalogList:[],
    ContentList:[],
    datalist:[],
    catalogtype:'',
    CatalogName:'',
    ShowTagsList:[],
    allContentList:[],
    rowcountnew:false
  };
  
  const mutations = {
  
  };
  
  const actions = {
  
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions
  };
  
  


// WEBPACK FOOTER //
// ./src/store/sofasniper.js